import { Box, Chip, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import AppFooter from "../../components/footer";
import NavBar from "../../components/NavBar";
import { resetSearchFilter } from "../../lib/redux/slices/searchKeysSlice";
import { fetchWorker } from "../../lib/redux/slices/workerSlice";
import AllWorkers from "./AllWorkers";
import Products from "./Products";
import Ecommerce from "./Ecommerce";
import ServicesBlogs from "./Blogs";


const HomePage = () => {
  const { palette } = useTheme();
  const dispatch = useDispatch();
  const searchKeys = useSelector((state) => state.searchKeysReducer.searchKeys);
  const subServiceId = useSelector(
    (state) => state.activeSubServiceIdReducer.subServiceId
  );

  const isEmpty =
    searchKeys?.workerName ||
    searchKeys?.workerLocation ||
    searchKeys?.workerRating ||
    searchKeys?.workerDateTime
      ? false
      : true;

  const handleResetFilter = (e) => {
    if (subServiceId) {
      const query = {
        serviceId: subServiceId,
        lat: "",
        lng: "",
        name: "",
        rating: 0,
        date: "",
      };

      dispatch(resetSearchFilter());
      dispatch(fetchWorker(query));
    }
  };

  return (
    <Box position={"relative"}>
      <NavBar />
      {/* <TranslateComponent/> */}

      <AllWorkers />

      <Products />
      <Ecommerce />
      <ServicesBlogs />
      {/* <PromoVideo /> */}
      {/* <HowWorks /> */}
      {/* <Tracking /> */}
      {/* <JoinUs /> */}
      <AppFooter bgcolor={true} />
      {!isEmpty && (
        <Chip
          label="Reset Filters"
          onClick={handleResetFilter}
          sx={{
            position: "fixed",
            bottom: 15,
            right: 10,
            zIndex: 1000,
            color: palette.common.white,
            backgroundColor: palette.primary.main,
            display: {
              xs: "none",
              sm: "none",
              md: "flex",
              lg: "flex",
              xl: "flex",
            },
          }}
        />
      )}
    </Box>
  );
};

export default HomePage;
